import { render, staticRenderFns } from "./CustomerIPBlacklist.vue?vue&type=template&id=185fa4a6"
import script from "./CustomerIPBlacklist.vue?vue&type=script&lang=js"
export * from "./CustomerIPBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports